import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  /* Register your custom font */
  @font-face {
    font-family: "HelveticaNeueLTPro-Bd";
    src: url("/fonts/HelveticaNeueLTPro-Bd.woff2") format("woff2"),
         url("/fonts/HelveticaNeueLTPro-Bd.woff") format("woff"),
         url("/fonts/HelveticaNeueLTPro-Bd.ttf") format("truetype");
    font-weight: bold;
    font-style: normal;
  }

  body {
    font-family: "Spline Sans Mono", monospace;
    font-optical-sizing: auto;
    font-weight: 400; /* Default weight */
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background: #000;
  }

  .light {
    font-weight: 300;
  }

  .bold {
    font-weight: 700;
  }

  .italic {
    font-style: italic;
  }
`;

export default GlobalStyle;
